<template>
  <div class="command-console" ref='commandConsole'>
        <div v-for="(output, index) in consoleOutput" :key="index" 
            :style="{ backgroundColor: output.backgroundColor, borderTop: `1px solid ${output.borderColor}`, borderBottom: `1px solid ${output.borderColor}` }" 
            class="p-2 d-flex flex-row">
            <i :class="output.icon" :style="{ color: output.iconColor }" class="mt-1"/>
            <span class="ml-2 flex-grow-1 console-line">{{ output.message }}</span>
        </div>
    </div>
</template>

<script>

export default {
  name: 'CommandCentreConsole',
  props: {
    consoleOutput: Array
  },
  watch: {
    consoleOutput() {
        this.$nextTick(() => {
            const commandConsole = this.$refs.commandConsole;
            commandConsole.scrollTop = commandConsole.scrollHeight;
        });
    }
  }
};
</script>

<style scoped>
.command-console {
  border: 2px solid #e8e8e8;
  border-radius: 0.25rem;
  margin: 8px 0px;
  overflow-y: scroll;
  height: 150px;
}

.console-line {
  display: inline-block;
  word-wrap: break-word;
  white-space: pre-wrap;
  width: 100%;
}
</style>
